import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export const CryptoLogo: React.FC<{ tokenName: string; size?: number; className?: string }> = ({
  tokenName,
  size = 32,
  className,
}) => {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [tokenName]);

  return (
    !imageError && (
      <img
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={twMerge(`size-[${size}px]`, className)}
        width={size}
        height={size}
        src={`/coins/${tokenName}.svg`}
        onError={() => setImageError(true)}
      />
    )
  );
};
